<template>
  <div class="container tem040">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="_mb-sm-50">携帯電話番号の登録変更</HeadingOne>

    <WizardGroup class="_mb-sm-50 _mb-md-60">
      <MainWizard :active-index="2" type="phone"></MainWizard>
    </WizardGroup>

    <section class="_mb-sm-50 _mb-md-60">
      <ContactBox class="_mb-md-10 _mb-sm-10">
        <CardHeader class="_pb-md-0 _pb-sm-0">以下の内容で変更いたしました。</CardHeader>
        <CardBody>
          <p class="_mb-md-0 _mb-sm-0">
            今後のお借り入れ・お客さま情報変更はSMSによる追加認証が必要となります。<br />
            一度トップページへお戻りいただき、改めてご希望のお手続きをご選択ください。
          </p>
        </CardBody>
      </ContactBox>
    </section>

    <section>
      <TableGroup>
        <TableBox>
          <TableBody>
            <TableRow>
              <TableHeader> 電話番号（その他） </TableHeader>
              <TableData :has-error="errors['phone']">
                <InputGroup :errors="errors" :prop-names="['phone']">
                  <div>{{ userData.phone_mobile_1 }}-{{ userData.phone_mobile_2 }}-{{ userData.phone_mobile_3 }}</div>
                </InputGroup>
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>
      </TableGroup>

      <BtngroupDouble class="-margin-lg _mb-sm-40 _mb-md-30">
        <template #main>
          <BtnMain class="-normal" router-name="mb001"> トップページへ </BtnMain>
        </template>
      </BtngroupDouble>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import {
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import TableGroup from "@/components/tables/TableGroup";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import InputGroup from "@/components/input/InputGroup";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import MainWizard from "@/components/wizard/MainWizard";
import WizardGroup from "@/components/wizard/WizardGroup";
import ContactBox from "@/components/box/ContactBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "../components/card/CardBody";

export default {
  name: "Tem040",
  components: {
    BtnMain,
    BtngroupDouble,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    HeadingOne,
    BreadcrumbGroup,
    InputGroup,
    MainWizard,
    WizardGroup,
    ContactBox,
    CardHeader,
    CardBody,
  },
  setup() {
    setMeta({
      title: "電話番号登録変更",
      description: "",
      keywords: "",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "お客さま情報の確認・変更",
          routerName: "mb023",
        },
        {
          text: "携帯電話番号の登録変更",
          active: true,
        },
      ],
      errors: {},
      userData: {
        id_type: "",
        account_id: "",
        name_kanji: "",
        name_kana: "",
        firstname_kana: "",
        firstname_kanji: "",
        lastname_kana: "",
        lastname_kanji: "",
        bth: "",
        sex: "",
        phone_au_1: "",
        phone_au_2: "",
        phone_au_3: "",
        phone_mobile_1: "",
        phone_mobile_2: "",
        phone_mobile_3: "",
        repayment_date: "",
        contractual_repayment_cycle: "",
        postcode: "",
        address_region: "",
        address_city: "",
        address_street: "",
        address_building: "",
        address_kana: "",
        home_type: "",
        nky_ngt: "",
        rent_loan_amount: "",
        marriage_status: "",
        number_of_children: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.TableData {
  > .red {
    color: $danger;
    font-weight: bold;
  }
}
.btn-text {
  &:hover {
    text-decoration: underline;
    color: $orange !important;
  }
}
.contact-box {
  > .card-body {
    justify-content: flex-start;
  }
}

.tem040 {
  :deep(.contact-box) {
    border: 1px solid #cccccc;
    border-radius: 10px;
    margin: inherit;
  }
}
</style>
